import {Component, inject, input} from '@angular/core';
import {ButtonComponent} from "@components";
import {CurrencyPipe} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {IconDirective, TrashIconComponent} from "@icons";
import {CartItem, CartService} from "../../../services/cart.service";

@Component({
  selector: 'wun-artwork-card',
  standalone: true,
  imports: [
    ButtonComponent,
    CurrencyPipe,
    FormsModule,
    IconDirective,
    TrashIconComponent
  ],
  templateUrl: './artwork-card.component.html',
  styleUrl: './artwork-card.component.scss'
})
export class ArtworkCardComponent {
  public readonly cartService = inject(CartService);
  editable = input(true)
  artwork = input.required<CartItem>();
  cartSummary = input(false);
}
